// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C898","left":"styles_left__1jgqY","desktopActions":"styles_desktopActions__1Vmmh","title":"styles_title__NhhTf"};